import React from 'react'
import Select from 'react-select'
import { PAGIINATION_OPTION } from "../StaticData/DataHelper";
import { getSingleSelected } from '../shared/CommonFuctions';
import { Grid, Pagination } from '@mui/material';
const PaginationAdvance = ({ page_Size, handlePageSizeCahange, counData, page_Index, handleChangePageIndex }) => {

    return (
        <Grid display={'flex'}>
            <Select
                options={PAGIINATION_OPTION}
                // defaultValue={PAGIINATION_OPTION[1]}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: '#25258f',
                        primary25: '#ecebef',
                        primary50: '#e1dfea',
                    },
                })}
                onChange={handlePageSizeCahange}
                value={getSingleSelected(
                    page_Size.toString(),
                    PAGIINATION_OPTION
                )}
                />
            <Pagination
                color="primary"
                count={counData}
                page={page_Index}
                onChange={handleChangePageIndex}
            />
        </Grid>
    )
}

export default PaginationAdvance